import { guessLetter } from './events'
import { $word as $ } from './store'

export const wordService = {
  $,
  guessLetter,
}
